import {
  BanknotesIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ClipboardDocumentCheckIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  HomeIcon,
  ShieldCheckIcon,
  TagIcon,
  UserCircleIcon,
  UsersIcon,
  AcademicCapIcon,
  BookOpenIcon,
} from '@heroicons/react/24/solid';

const userGuideItem = { label: 'User guide', icon: BookOpenIcon, path: '/user-guide' };

export const studentNavItems = [
  { label: 'Portfolio', icon: UserCircleIcon, path: '/portfolio' },
  { label: 'Organizations', icon: BuildingOffice2Icon, path: '/organizations' },
  { label: 'Interviews', icon: ClipboardDocumentCheckIcon, path: '/my-interviews' },
  userGuideItem,
];

export const organizationAdminNavItems = [
  { label: 'Dashboard', icon: HomeIcon, path: '/organization/dashboard' },
  { label: 'Interviews', icon: CalendarDaysIcon, path: '/organization/interviews' },
  { label: 'Reviews', icon: ClipboardDocumentCheckIcon, path: '/organization/reviews' },
  { label: 'Experts', icon: UsersIcon, path: '/organization/experts' },
  { label: 'Settings', icon: Cog6ToothIcon, path: '/organization/settings' },
  userGuideItem,
];

export const expertNavItems = [
  { label: 'Evaluation reviews', icon: CalendarDaysIcon, path: '/expert/reviews' },
  { label: 'Assigned portfolios', icon: UsersIcon, path: '/expert/portfolios' },
  userGuideItem,
];

export const platformAdminNavItems = [
  { label: 'Platform console', icon: ShieldCheckIcon, path: '/platform' },
  { label: 'Organizations', icon: BuildingOffice2Icon, path: '/universities' },
  { label: 'Skills & templates', icon: TagIcon, path: '/platform/skills' },
  { label: 'Follow-up limits', icon: Cog6ToothIcon, path: '/admin/organizations' },
  { label: 'AI spend', icon: BanknotesIcon, path: '/admin/ai-spend' },
  { label: 'Provider credits', icon: CreditCardIcon, path: '/platform/credits' },
  { label: 'IB pilot requests', icon: AcademicCapIcon, path: '/platform/ib-pilot-requests' },
];

export const getNavigationItems = ({ isStudent, isExpert, isUniversity, isAdmin }) => {
  if (isStudent) return studentNavItems;
  if (isExpert) return expertNavItems;
  if (isUniversity) return organizationAdminNavItems;
  if (isAdmin) return platformAdminNavItems;
  return [{ label: 'My profile', icon: UserCircleIcon, path: '/profile' }];
};
